import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';
import CorporationTrustPreview from './CorporationTrust/preview';
import PreviewHomeSale from './HomeSale/preview';
import PreviewInvestments from './Investments/preview';
import PreviewOtherIncome from './OtherIncome/preview';
import PassiveIncomePreview from './PassiveIncome/preview';
import PreviewSelfEmployment from './SelfEmployment/preview';
import PreviewWages from './Wages/preview';

export interface IPreviewIncomeProps {}

export default function PreviewIncome(props: IPreviewIncomeProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Income">
        {routes.income.wages && <PreviewWages />}
        {routes.income.passiveIncome && <PassiveIncomePreview />}
        {routes.income.corporationTrust && <CorporationTrustPreview />}
        {routes.income.selfEmployment && <PreviewSelfEmployment />}
        {routes.income.otherIncome && <PreviewOtherIncome />}
        {routes.income.investments && <PreviewInvestments />}
        {routes.income.homeSale && <PreviewHomeSale />}
      </PreviewExpandable>
    </>
  );
}
